<div class="dropdown" [class.open]="isOpen">
	<div class="dropdown-header" (click)="toggleDropdown()">
		<span>{{ selectedCount }}</span> {{ 'channels.all_channels' | translate }}
		<img
			class="arrow"
			[class.rotated]="isOpen"
			src="assets/arrow_dropdown.svg"
		/>
	</div>
	<div class="dropdown-menu" *ngIf="isOpen">
		<div class="item button" (click)="toggleSelectAll()">
			<div class="checkbox none" [class.checked]="areAllSelected()"></div>
			{{ 'channels.show_all' | translate }}
		</div>
		<div
			class="item"
			*ngFor="let channel of channels; let i = index"
			(click)="toggleChannel(channel)"
		>
			<div class="checkbox" [class.checked]="channel.selected"></div>
			<span class="channel-icon" [ngClass]="channel.icon"></span>
			{{ channel.name }}
		</div>
	</div>
</div>
